module.exports = __webpack_public_path__ + "static/media/miniAttachment.2a6abeb2.svg";